import React from 'react'
import UnifiedSalesForm from './UnifiedSalesForm'

const Sales = () => {
  return <UnifiedSalesForm />
}

export default Sales
